import { ResourceServiceType } from './resourceServiceTypes'
import { ResourcesInterface, ResourcesProps } from '../../../../index';
import axios from 'axios'
import { ReduxAction } from '../../../reducers/reducerType'
import { ServiceError } from '@bt-react/constants'
import get from 'lodash/get'
import has from 'lodash/has'
import AssetUploadLocation from '@bt-react/libs/AssetUploadLocation'

let BTUploader
if (typeof document !== 'undefined') {
  BTUploader = require('brighttalk-uploader').default
}

export const fetchResourceDataSuccess = (data: ResourcesInterface, communicationId: string): ReduxAction =>
  ({ type: ResourceServiceType.FETCH_RESOURCES_SUCCESS, payload: {data, communicationId} })

export const fetchResourceDataError = (error, communicationId): ReduxAction =>
  ({ type: ResourceServiceType.FETCH_RESOURCES_FAILED, payload: {error, communicationId} })

export const fetchResourceData = (channelId, webcastId, origin = '') => async (dispatch, getState): Promise<void> => {

  dispatch({ type: ResourceServiceType.FETCH_RESOURCES, payload: {communicationId: webcastId} })

  const state = getState()
  if (state.resources && state.resources.interval && origin !== 'cancel') {
    const interval = state.resources.interval
    if (interval && interval.length) {
      for (let i = 0; i < interval.length; i++) {
        clearInterval(interval[i])
      }
    }
  }

  try {

    const { data } = await axios.get(`/service/communication/v1/channel/${channelId}/communication/${webcastId}/resources`, {
      headers: {
        'BrightTALK-API-Client': state.client
      }
    })
    if (data.resources) {
      data.resources.forEach(val=>{
        if (val.file && !val.file.href) {
          if (origin !== 'cancel') {
            dispatch(checkAttachementUploadStatus(channelId, webcastId, val.id, 'list'))
          } else {
            val.isCancelled = true
          }
        }
      })
    }
    dispatch(fetchResourceDataSuccess(data, webcastId))

  }
  catch (e) {
    const status = get(e, 'request.status', 500)
    let errorMessage = {}

    switch (status) {

      case 500:
        errorMessage = {
          code: 500,
          message: ServiceError.NETWORK_ERROR
        }
        break
      default:
        errorMessage = {
          code: e.request.status,
          message: e.message
        }

    }

    dispatch(fetchResourceDataError(errorMessage, webcastId))

  }

}

export const setAttachmentView = (view: string, state?: boolean) => async (dispatch): Promise<void> => {
  if (state) {
    dispatch({type: ResourceServiceType.SET_VIEW_ONLY, payload: view})
  } else {
    dispatch({type: ResourceServiceType.SET_VIEW, payload: view})
  }
}

/*
*
* This function used for add webcast attachment
*
*/
export const addAttachments = (formData, userTimezone) => async (dispatch, getState) => {

  dispatch({ type: ResourceServiceType.SUBMITING_ATTACHMENT, payload: formData })
  const { client } = getState()
  let newAttachment
  let isSuccess = true
  const {channelId, webcastId, type, title, description, link, id} = formData
  const postData:any = {
    title: title,
    description: description
  }
  if (type==='file') {
    postData.file = {hosted: 'internal'}
  } else if (type==='link') {
    postData.link = {href: link}
  }
  try {
    let response
    if (id) {
      postData.id = id
      response = await axios.put(`/service/communication/v1/channel/${channelId}/communication/${webcastId}/resource/${postData.id}`, postData, {
        headers: {
          'BrightTALK-API-Client': client
        }
      })
    } else {
      response = await axios.post(`/service/communication/v1/channel/${channelId}/communication/${webcastId}/resource`, postData, {
        headers: {
          'BrightTALK-API-Client': client
        }
      })
    }
    const { data } = response
    newAttachment = data

  } catch (e) {

    if (has(e, 'response.data')) {

      isSuccess = false
      dispatch({ type: ResourceServiceType.SUBMIT_ATTACHMENT_ERROR, payload: {error:e.response.data, data: formData} })

    }

  }

  if (isSuccess) {

    if (newAttachment) {
      dispatch({type: ResourceServiceType.SUBMIT_ATTACHMENT_SUCCESS, payload: newAttachment})
      if (type === 'file' && !formData.file.hosted) {
        await dispatch(submitAttachmentForm(newAttachment, formData, channelId, webcastId, userTimezone))
      } else {
        dispatch(fetchResourceData(channelId, webcastId))
      }
    } else {

      dispatch({ type: ResourceServiceType.SUBMIT_ATTACHMENT_ERROR, payload: {code: 'error', message: 'Failed to create'} })

    }

  }
}

/*
*
* This function used to submit the attachment form
*
*/
export const submitAttachmentForm = (attachment, formData, channelId, webcastId, userTimezone) => async (dispatch, getState) => {

  dispatch({ type: ResourceServiceType.SELECT_ATTACHMENT_UPLOAD })

  const uploader = await BTUploader.initialise({
    'browse_button': document.createElement('div'),
    uploadOnly: true,
    filters: {
      'max_file_size': '1000mb'
    }
  })

  window.onbeforeunload = () => {

    const state = getState()

    return state.resources.status.isProcessing ? true : undefined

  }

  const attachmentFilePromise = new Promise<void>((resolve, reject) => {
    if (!(formData.file instanceof Blob)) {

      return resolve()

    }

    uploader.on(BTUploader.FILE_UPLOADED, (file) => {

      dispatch({ type: ResourceServiceType.ATTACHMENT_UPLOAD_SUCCESS })
      dispatch(checkAttachementUploadStatus(channelId, webcastId, file.id))
      resolve()

    })

    uploader.on(BTUploader.PROGRESS, (file, bytePerSec) => {

      dispatch({ type: ResourceServiceType.ATTACHMENT_UPLOADING_STATE, payload: {file, bytePerSec}})
      resolve()

    })

    uploader.on(BTUploader.PROCESSING, (file) => {

      dispatch({ type: ResourceServiceType.ATTACHMENT_PROCESSING_STATE })

    })

    uploader.on(BTUploader.FILE_FINISHED, (file) => {

      dispatch({ type: ResourceServiceType.ATTACHMENT_PROCESS_SUCCESS })
      dispatch(fetchResourceData(channelId, webcastId))

    })

    uploader.on(BTUploader.ERROR, (e) => {

      dispatch({ type: ResourceServiceType.ATTACHMENT_UPLOAD_FAILED, payload: e })
      resolve()

    })
    try {
      uploader.addFile(formData.file)
    
      const region = AssetUploadLocation(userTimezone)

      uploader.start({
        type: 'resource-fileupload',
        target: {
          id: attachment.id,
          type: 'resource'
        },
        region: region
      })
      dispatch({ type: ResourceServiceType.ADD_UPLOADER, payload: uploader})
    } catch (e) {
      dispatch({ type: ResourceServiceType.ATTACHMENT_UPLOAD_FAILED, payload: e })
      resolve()

    }

  })

  const actions = [
    attachmentFilePromise
  ]
  try {

    await Promise.all(actions)

  }
  catch (e) {    
    dispatch({ type: ResourceServiceType.ATTACHMENT_UPLOAD_FAILED, payload: attachment })
  }

}

export const deleteResource = (channelId, webcastId, attachmentId, origin='') => async (dispatch, getState): Promise<void> => {

  const { client } = getState()

  if (['client', 'cancel', 'delete'].indexOf(origin) >= 0) dispatch({ type: ResourceServiceType.DELETE_RESOURCE, payload: {communicationId: webcastId} })

  if (origin === 'back') {
    dispatch(fetchResourceData(channelId, webcastId))
    return
  }

  const state = getState()

  const uploader = state.resources.uploader
  if (uploader) {
    uploader.destroy()
  }

  await dispatch(cancelFileUpload(attachmentId))

  if ((!has(state, 'resources.status.isEdit') || origin === 'delete') && origin !== 'processing') {

    try {

      const { data } = await axios.delete(`/service/communication/v1/channel/${channelId}/communication/${webcastId}/resource/${attachmentId}`, {
        headers: {
          'BrightTALK-API-Client': client
        }
      })
      await dispatch({ type: ResourceServiceType.DELETE_RESOURCE_SUCCESS })
      dispatch({ type: ResourceServiceType.SET_VIEW, payload: 'lists' })
      dispatch(fetchResourceData(channelId, webcastId, 'cancel'))

    } catch (e) {
      const status = get(e, 'request.status', 500)
      let errorMessage = {}

      switch (status) {

        case 500:
          errorMessage = {
            code: 500,
            message: ServiceError.NETWORK_ERROR
          }
          break
        default:
          errorMessage = {
            code: e.request.status,
            message: e.message
          }

      }

      dispatch({ type: ResourceServiceType.DELETE_RESOURCE_FAILED, payload: errorMessage })
    }

  } else {
    if (origin !== 'processing') {
      dispatch({ type: ResourceServiceType.GOTO_LISTING_PAGE })
      if (origin === 'cancel') dispatch(fetchResourceData(channelId, webcastId, 'cancel'))
    }
  }

}

export const selectAttachment = (attachmentInfo: ResourcesProps) => async (dispatch): Promise<void> => {
  dispatch({type: ResourceServiceType.SELECT_ATTACHMENT, payload: attachmentInfo})
}

export const rearrangeResource = (channelId, webcastId, formData) => async (dispatch, getState): Promise<void> => {

  const { client } = getState()
  dispatch({ type: ResourceServiceType.REARRANGE_RESOURCE, payload: {communicationId: webcastId} })

  try {

    const { data } = await axios.put(`/service/communication/v1/channel/${channelId}/communication/${webcastId}/resources`, {resources: formData}, {
      headers: {
        'BrightTALK-API-Client': client
      }
    })
    await dispatch({ type: ResourceServiceType.REARRANGE_RESOURCE_SUCCESS, payload: {data} })

  } catch (e) {
    const status = get(e, 'request.status', 500)
    let errorMessage = {}

    switch (status) {

      case 500:
        errorMessage = {
          code: 500,
          message: ServiceError.NETWORK_ERROR
        }
        break
      default:
        errorMessage = {
          code: e.request.status,
          message: e.message
        }

    }

    dispatch({ type: ResourceServiceType.REARRANGE_RESOURCE_FAILED, payload: errorMessage })

  }

}

export const fetchResourceSetting = () => async (dispatch): Promise<void> => {

  dispatch({ type: ResourceServiceType.FETCH_RESOURCE_SETTING })

  try {

    const { data } = await axios.get(`/service/ams/settings/fileupload`)
    await dispatch({ type: ResourceServiceType.FETCH_RESOURCE_SETTING_SUCCESS, payload: {data} })

  } catch (e) {
    const status = get(e, 'request.status', 500)
    let errorMessage = {}

    switch (status) {

      case 500:
        errorMessage = {
          code: 500,
          message: ServiceError.NETWORK_ERROR
        }
        break
      default:
        errorMessage = {
          code: e.request.status,
          message: e.message
        }

    }

    dispatch({ type: ResourceServiceType.FETCH_RESOURCE_SETTING_FAILED, payload: errorMessage })

  }

}

export const fetchVideoSettings = (BTSESSION?) => async (dispatch, getState): Promise<void> => {

  dispatch({ type: ResourceServiceType.FETCH_VIDEO_SETTINGS })

  const state = getState()

  let host = ''

  const headers: {
    Accept: string,
    Cookie?: string,
    withCredentials?: boolean
  } = {
    Accept: 'application/json'
  }

  if (BTSESSION) {

    headers.Cookie = 'BTSESSION=' +  encodeURIComponent(BTSESSION)
    host = state.config.host

  } else {

    headers.withCredentials = true

  }

  try {

    const { data } = await axios.get(`${host}/service/ams/settings/video`, {
      headers
    })
    await dispatch({ type: ResourceServiceType.FETCH_VIDEO_SETTINGS_SUCCESS, payload: {data} })
    return data

  } catch (e) {
    const status = get(e, 'request.status', 500)
    let errorMessage = {}

    switch (status) {

      case 500:
        errorMessage = {
          code: 500,
          message: ServiceError.NETWORK_ERROR
        }
        break
      default:
        errorMessage = {
          code: e.request.status,
          message: e.message
        }

    }

    dispatch({ type: ResourceServiceType.FETCH_VIDEO_SETTINGS_FAILED, payload: errorMessage })

  }

}

export const getUploadedImage = (url) => async (dispatch, getState) => {

  const { client } = getState()
  try {

    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'BrightTALK-API-Client': client
      }
    })

    return res
  } catch(e) {
    throw new Error(e.message)
  }

}

export const updateCancelState = (channelId, webcastId, resourceId, status = true) => async (dispatch, getState) => {

  try {
  const state = getState()
  if (state.resources && webcastId && state.resources[webcastId] && state.resources[webcastId].data && state.resources[webcastId].data.resources) {

    const index = get(state.resources[webcastId].data, 'resources').findIndex((val)=> val.id === resourceId)
    if (index !== -1) {
      if (status) {
        const url = `/service/communication/v1/channel/${channelId}/communication/${webcastId}/resource/${resourceId}`
        const res = await dispatch(getUploadedImage(url))
        res.data.isCancelled = status
        state.resources[webcastId].data.resources[index] = res.data
      } else {
        state.resources[webcastId].data.resources[index].isCancelled = status
      }
      const resources = state.resources[webcastId]
      dispatch({ type: ResourceServiceType.UPDATE_CANCELLED_STATE, payload: {resources, webcastId} })

    }

  }
  } catch (e) {
    throw new Error(e.message)
  }

}

export const checkAttachementUploadStatus = (channelId, webcastId, resourceId, state = '') => async (dispatch): Promise<void> => {

  let processingState = false
  let assetId = resourceId
  if (state === 'list') {
    try {
      const url = `/service/ams/resource/${resourceId}/settings/fileupload`
      const res = await dispatch(getUploadedImage(url))
      if (res.data.asset) {
        if (['complete', 'cancelled', 'uploading', 'processingfailed'].includes(res.data.asset.status.state)) {
          dispatch(updateCancelState(channelId, webcastId, resourceId))
        } else {
          processingState = true
          assetId = res.data.asset.id
          dispatch(updateCancelState(channelId, webcastId, resourceId, false))
        }
      } else {
        dispatch({ type: ResourceServiceType.ATTACHMENT_NOT_FOUND, payload: { resourceId } })
        dispatch(updateCancelState(channelId, webcastId, resourceId))
      }
    } catch (e) {
      dispatch(updateCancelState(channelId, webcastId, resourceId))
    }
  }

  if (state!=='list' || processingState) {

    const attachmentProcessingTimer = setInterval(async () => {

      try {
        const url = `/service/ams/asset/${assetId}`
        const res = await dispatch(getUploadedImage(url))
        if (res.data.id) {
          if (['complete', 'cancelled'].includes(res.data.status.state)) {

            clearInterval(attachmentProcessingTimer)
            if (state === 'list') {
              dispatch(updateCancelState(channelId, webcastId, resourceId))
            } else if (res.data.status.state !== 'cancelled') {
              dispatch({ type: ResourceServiceType.ATTACHMENT_PROCESS_SUCCESS })
              dispatch(fetchResourceData(channelId, webcastId))
            }

          } else {
            if (state === 'list') {
              dispatch(updateCancelState(channelId, webcastId, resourceId, false))
            } else if (res.data.status.state === 'processingfailed') {
              dispatch({ type: ResourceServiceType.ATTACHMENT_PROCESSING_FAILED, payload: {error: 'processing failed'} })
            }
          }

        } else {

          dispatch({ type: ResourceServiceType.ATTACHMENT_NOT_FOUND, payload: { resourceId } })
          clearInterval(attachmentProcessingTimer)

          if (state === 'list') dispatch(updateCancelState(channelId, webcastId, resourceId))

        }
      } catch (e) {

        clearInterval(attachmentProcessingTimer)
        if (state === 'list') dispatch(updateCancelState(channelId, webcastId, resourceId))
      }

    }, 5000)
    dispatch({ type: ResourceServiceType.SAVE_STATUS_INTERVAL, payload: attachmentProcessingTimer})
    if (state !== 'list') {
      dispatch({ type: ResourceServiceType.ATTACHMENT_PROCESSING_STATE })
    }

  }

}

export const cancelFileUpload = (resourceId) => async (dispatch): Promise<void> => {

  try {
    const url = `/service/ams/resource/${resourceId}/settings/fileupload`
    const res = await dispatch(getUploadedImage(url))

    if (res.data.asset) {
      try {
    
        const response = await axios.put(`/service/ams/asset/${res.data.asset.id}`, {id: resourceId, status: {state: 'cancelled'}})
      
      } catch (e) {
        const status = get(e, 'request.status', 500)
        let errorMessage = {}

        switch (status) {

          case 500:
            errorMessage = {
              code: 500,
              message: ServiceError.NETWORK_ERROR
            }
            break
          default:
            errorMessage = {
              code: e.request.status,
              message: e.message
            }

        }
      
      }
    }
  } catch (e) {

  }
      
}

export const getVideoAssetByWebcastId = (webcastId: string, BTSESSION?) => async (dispatch, getState): Promise<string | null> => {

  const state = getState()

  let host = ''

  const headers: {
    Accept: string,
    Cookie?: string,
    withCredentials?: boolean
  } = {
    Accept: 'application/json'
  }

  if (BTSESSION) {

    headers.Cookie = 'BTSESSION=' +  encodeURIComponent(BTSESSION)
    host = state.config.host

  } else {

    headers.withCredentials = true

  }

  try {

    const response = await axios.get(`${host}/service/ams/communication/${webcastId}/settings/video`, {headers})
    return response.data.asset
  } catch (e) {
    
    return null
  
  }

}
